import apiDefaultConfig from './coreApiDefaultConfig'
import { runCoreApiGetRequest, runCoreApiPostRequest } from '@/coreApi/coreApi'
import { getCurrentAccountData, getCurrentProjectData } from '@/auth/utils'

export function getAccountDetails() {
    const account = getCurrentAccountData()

    const url = `${apiDefaultConfig.accountDetails
        .replace('{account_id}', account.accountId)}`

    return runCoreApiGetRequest(url)
}

export function getAccountUsers() {
    const account = getCurrentAccountData()
    const url = `${apiDefaultConfig.accountUsers
        .replace('{account_id}', account.accountId)}`

    return runCoreApiGetRequest(url)
}

export function getAccountUserDetails(accountUserId) {
    const account = getCurrentAccountData()
    const url = `${apiDefaultConfig.accountUserDetails
        .replace('{account_id}', account.accountId)
        .replace('{account_user_id}', accountUserId)}`

    return runCoreApiGetRequest(url)
}

export function addAccountUser(data) {
    const account = getCurrentAccountData()
    const url = `${apiDefaultConfig.accountUserAdd
        .replace('{account_id}', account.accountId)}`

    return runCoreApiPostRequest(url, { user_data: data })
}

export function editAccountUser(accountUserId, data) {
    const account = getCurrentAccountData()
    const url = `${apiDefaultConfig.accountUserEdit
        .replace('{account_id}', account.accountId)
        .replace('{account_user_id}', accountUserId)}`

    return runCoreApiPostRequest(url, { user_data: data })
}

export function deleteAccountUser(accountUserId) {
    const account = getCurrentAccountData()
    const url = `${apiDefaultConfig.accountUserDelete
        .replace('{account_id}', account.accountId)
        .replace('{account_user_id}', accountUserId)}`

    return runCoreApiPostRequest(url)
}


